var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "divBox" },
    [
      _vm.checkBtn
        ? _c(
            "div",
            [
              _c("el-card", { staticClass: "employees-card-bottom" }, [
                _c(
                  "div",
                  [
                    _c(
                      "div",
                      { staticClass: "plan-tabs-content mb20" },
                      [
                        _c(
                          "el-tabs",
                          {
                            model: {
                              value: _vm.tabCur,
                              callback: function ($$v) {
                                _vm.tabCur = $$v
                              },
                              expression: "tabCur",
                            },
                          },
                          [
                            _c("el-tab-pane", {
                              attrs: { label: "当前考核", name: "0" },
                            }),
                            _vm._v(" "),
                            _c("el-tab-pane", {
                              attrs: { label: "我的自评", name: "1" },
                            }),
                            _vm._v(" "),
                            _c("el-tab-pane", {
                              attrs: { label: "考核统计", name: "2" },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _vm.tabCur == 0
                      ? _c("current", { attrs: { id: _vm.id } })
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.tabCur == 1
                      ? _c("self", {
                          ref: "self",
                          on: { selfHandleCheck: _vm.selfHandleCheck },
                        })
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.tabCur == 2
                      ? _c("assess-statistics", {
                          ref: "assessStatistics",
                          attrs: { "is-mine": true },
                        })
                      : _vm._e(),
                  ],
                  1
                ),
              ]),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      !_vm.checkBtn
        ? _c("audit-process", {
            ref: "auditProcess",
            attrs: {
              id: _vm.id,
              "is-tips": _vm.isTips,
              rowData: _vm.rowData,
              "process-index": _vm.status,
              strType: _vm.strType,
            },
            on: { saveOk: _vm.saveOk, auditProcess: _vm.auditProcess },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }